module.exports = __webpack_public_path__ + "img/share-preview.989af48c.png";